import { useStore } from "@nanostores/react"

import { map } from "nanostores"

import {
  setPersistentSidebarExpanded,
  usePersistentSidebarExpanded
} from "./persistent-sidebar-store"

interface AppSidebarState {
  isOpen: boolean
}

const appSidebarStore = map<AppSidebarState>({
  isOpen: false
})

function open() {
  appSidebarStore.setKey("isOpen", true)
}

function close() {
  appSidebarStore.setKey("isOpen", false)
}

function toggleOpen() {
  const currentState = appSidebarStore.get()
  appSidebarStore.setKey("isOpen", !currentState.isOpen)
}

function resetToDefaults() {
  appSidebarStore.set({
    isOpen: false
  })
  setPersistentSidebarExpanded(true)
}

export const setIsExpanded = setPersistentSidebarExpanded

export function useAppSidebar() {
  const state = useStore(appSidebarStore)
  const isExpanded = usePersistentSidebarExpanded()

  return {
    isOpen: state.isOpen,
    isExpanded: isExpanded ?? true, // Default to true if undefined

    open,
    close,
    toggleOpen,
    setIsExpanded,
    resetToDefaults
  }
}
